import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardTwoToneIcon from "@mui/icons-material/DashboardTwoTone";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import Dashboard from "../../shared/assets/icons/Dashboard";
import AllCampaigns from "../../shared/assets/icons/AllCampaigns";
import { Skeleton } from "@mui/material";

// import "./sidebarClient.css";
import {
  Database,
  DoubleArrowDown,
  Logout,
  Music,
  Setting,
  Support,
  Users,
  VideoIcon,
  Volume,
} from "../../shared/assets/icons";
import img1 from "../../shared/assets/icons/client-logo.webp";
const Sidebar = ({ isOpen, toggleSidebar, setIsOpen, logo }) => {
  const ulRef = useRef(null);
  const navigate = useNavigate();

  const [isArrow, setIsArrow] = useState(true);
  const location = useLocation();
  const activeMenu = location.pathname.split("/").pop();
  const dummyOrgLogo = "https://via.placeholder.com/100x100.png?text=Logo";

  const scrollToLastItem = () => {
    if (ulRef.current) {
      const lastItem = ulRef.current.lastElementChild;
      lastItem?.scrollIntoView({ behavior: "smooth", block: "end" });

      // Check if the element has scrolled to the bottom
      const { scrollTop, scrollHeight, clientHeight } = ulRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        setIsArrow(false); // Hide the arrow immediately after scrolling to the bottom
      }
    }
  };
  const handleScroll = () => {
    if (ulRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = ulRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 1) {
        setIsArrow(false);
      } else {
        setIsArrow(true);
      }
    }
  };

  useEffect(() => {
    const ulElement = ulRef.current;
    if (ulElement) {
      ulElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (ulElement) {
        ulElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div
      className={`bg-white text-black fixed h-full z-50 flex flex-col justify-between items-center
    ${isOpen ? "w-64" : "w-16"}
    transition-all duration-300`}
    >
      <div className="p-4 flex flex-col justify-center items-center">
        <div className="flex justify-between  items-center   ">
          {/* <h2
            className={`text-xl font-bold mr-28 ${isOpen ? "block" : "hidden"}`}
          >
            Pixell
          </h2> */}
          <img
            src={logo ? logo : img1}
            alt="logo"
            className={`text-xl h-10 w-10 rounded-md font-bold mr-28 ${
              isOpen ? "block" : "hidden"
            }`}
          />

          <button
            onClick={toggleSidebar}
            className="focus:outline-none h-10 w-10 "
          >
            {isOpen ? (
              <FaTimes className="h-6 w-6 ml-8 " />
            ) : (
              <>
                <img
                  src={logo ? logo : img1}
                  alt="logo"
                  className="h-10 w-10 rounded-md object-cover"
                />
              </>
            )}
          </button>
        </div>
        <div className={`h-80`}>
          {/* ----------------------------------------------------------------------------------------------------------- */}
          <ul
            ref={ulRef}
            className="mt-8 border-b-2 max-h-full scrollBarHide space-y-3"
          >
            {[
              ...(localStorage.getItem("userRole") == 1
                ? [
                    {
                      name: "Dashboard",
                      link: "dashboard",
                      icon: <Dashboard />,
                      menu: "dashboard",
                    },
                  ]
                : []),

              // { name: "RFP", link: "RFP", icon: <VideoIcon />, menu: "RFP" },
              { name: "Users", link: "Users", icon: <Users />, menu: "Users" },
              {
                name: "All Campaigns",
                link: "AllCampaigns",
                icon: <AllCampaigns />,
                menu: "AllCampaigns",
              },
            ].map(({ name, link, icon, menu }) => (
              <Tooltip key={menu} title={name} placement="bottom" arrow>
                <Link to={link}>
                  <li
                    className={`py-2 px-4 flex items-center justify-start cursor-pointer my-2 rounded-md transition-all duration-300 ${
                      activeMenu === menu ? "bg-blue-100" : ""
                    }`}
                  >
                    <span className="w-6 h-6 flex items-center justify-center">
                      {React.cloneElement(icon, {
                        sx: { color: activeMenu === menu ? "black" : "grey" }, // Dynamic color styling
                      })}
                    </span>
                    <span
                      className={`flex-1 text-left ml-2 ${
                        isOpen ? "block" : "hidden"
                      } ${
                        activeMenu === menu
                          ? "text-[var(--primary-color)]"
                          : "text-[var(--para-color)]"
                      }`}
                    >
                      {name}
                    </span>
                  </li>
                </Link>
              </Tooltip>
            ))}
          </ul>

          <div
            className={` mt-2 ${isArrow ? "block" : "hidden"}
            ${isOpen ? "ml-24" : "ml-3.5 mt-2"}`}
            onClick={scrollToLastItem}
            title="Scroll Down"
          >
            <DoubleArrowDown size="22" />
          </div>
        </div>
      </div>

      <ul className="mb-4 flex flex-col justify-center items-center">
        <Tooltip title="Account Setting" placement="right-start" arrow={true}>
          <Link to="account">
            <li
              className={`py-2 px-4 flex items-center cursor-pointer ${
                activeMenu === "account"
                  ? "bg-[var(--bg-color)]  rounded-md "
                  : ""
              }`}
            >
              <Setting
                color={
                  activeMenu === "account" ? "var(--primary-color)" : "grey"
                }
              />
              <span
                className={` ml-3  mr-20  ${isOpen ? "block" : "hidden"}  ${
                  activeMenu === "account"
                    ? `text-[var(--primary-color)]`
                    : `text-[var(--para-color)] `
                }`}
              >
                {" "}
                Setting
              </span>
            </li>
          </Link>
        </Tooltip>
        {/* <Link to="">
          <li
            className={`py-2 px-4 flex items-center cursor-pointer ${activeMenu === "vendor" ? "bg-gray-900" : ""
              }`}
          >
            <Support color="grey" />
            <span
              className={` ml-3  mr-20  ${isOpen ? "block" : "hidden"}  ${
                activeMenu === "support"
                  ? `text-[var(--primary-color)]`
                  : `text-[var(--para-color)] `
              }`}
            >
              Support
            </span>
          </li>
        </Link> */}
        <Tooltip title="Logout" placement="right-start" arrow={true}>
          <li
            className={`py-2 px-4 flex text-sm items-center cursor-pointer ${
              activeMenu === "vendor" ? "bg-gray-900" : ""
            }`}
            onClick={() => {
              Swal.fire({
                text: "Do you want to logout?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Logout",
                cancelButtonText: "Cancel",
              }).then((result) => {
                if (result.isConfirmed) {
                  // Remove items from localStorage
                  localStorage.removeItem("token");
                  localStorage.removeItem("role");
                  localStorage.removeItem("email");
                  localStorage.removeItem("isClientOnBoarded");
                  localStorage.removeItem("phoneNumber");
                  localStorage.removeItem("userRole");
                  localStorage.removeItem("clientId");
                  localStorage.removeItem("name");
                  localStorage.removeItem("userId");

                  // Navigate to the login page

                  // Optionally show a success message
                  Swal.fire(
                    "Logged Out",
                    "You have been logged out successfully.",
                    "success",
                  ).then(() => {
                    navigate("/user");
                  });
                }
              });
            }}
          >
            <Logout color="grey" />
            <span
              className={`ml-3 mr-20 ${isOpen ? "block" : "hidden"} ${
                activeMenu === "Logout"
                  ? `text-[var(--primary-color)]`
                  : `text-[var(--para-color)] `
              }`}
            >
              Logout
            </span>
          </li>
        </Tooltip>
      </ul>
    </div>
  );
};

export default Sidebar;
